import { render, staticRenderFns } from "./QuelpThread.vue?vue&type=template&id=2feaabeb&scoped=true"
import script from "./QuelpThread.vue?vue&type=script&lang=js"
export * from "./QuelpThread.vue?vue&type=script&lang=js"
import style0 from "./QuelpThread.vue?vue&type=style&index=0&id=2feaabeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feaabeb",
  null
  
)

export default component.exports